import React, { useState } from 'react';
import { PasswordGate } from './components/PasswordGate';
import { CardStack } from './components/CardStack';
import { FinalScreen } from './components/FinalScreen';
type AppState = 'gate' | 'playing' | 'final';
export function App() {
  const [appState, setAppState] = useState<AppState>('gate');
  return <div className="w-full h-screen flex items-center justify-center overflow-hidden relative selection:bg-silver/30" data-id="element-0">
      {appState === 'gate' && <PasswordGate onUnlock={() => setAppState('playing')} data-id="element-1" />}

      {appState === 'playing' && <CardStack onComplete={() => setAppState('final')} data-id="element-2" />}

      {appState === 'final' && <FinalScreen onRestart={() => setAppState('playing')} data-id="element-3" />}
    </div>;
}